import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AgendaItemModel } from '../../../models/agenda-item.model';

@Component({
    selector: 'sl-voting-results',
    templateUrl: './voting-results.component.html',
    styleUrls: ['./voting-results.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VotingResultsComponent {
    agendaItem = input.required<AgendaItemModel>();
}
